/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Include_FsInputs */

const en_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include FS`)
};

const fr_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure FS`)
};

const de_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS einschließen`)
};

const it_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi FS`)
};

const ru_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить FS`)
};

const es_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir FS`)
};

const zh_cn2_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包括 FS`)
};

const ja_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FSを含める`)
};

const hi_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एफएस शामिल करें`)
};

const pt_pt2_subtitle_export_include_fs = /** @type {(inputs: Subtitle_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir FS`)
};

/**
* | output |
* | --- |
* | "Include FS" |
*
* @param {Subtitle_Export_Include_FsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_include_fs = /** @type {((inputs?: Subtitle_Export_Include_FsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Include_FsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_include_fs(inputs)
	if (locale === "de") return de_subtitle_export_include_fs(inputs)
	if (locale === "it") return it_subtitle_export_include_fs(inputs)
	if (locale === "ru") return ru_subtitle_export_include_fs(inputs)
	if (locale === "es") return es_subtitle_export_include_fs(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_include_fs(inputs)
	if (locale === "ja") return ja_subtitle_export_include_fs(inputs)
	if (locale === "hi") return hi_subtitle_export_include_fs(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_include_fs(inputs)
	return en_subtitle_export_include_fs(inputs)
});